import level1 from './level1.js';

const content = {
  label: "Home",
  description: "Home",
  img: "./images/00-homepage.jpg",
  imgDescription: "Vista globale dei 3 fogli che compongono la bolletta di Servizio Elettrico Nazionale.",
  level1: level1
};

export default content;
